module.exports = __webpack_public_path__ + "img/a1.70931302.png";